// src/features/records/contexts/RecordDetailContext.js
import { createContext } from 'react';

/**
 * Context for managing RecordDetail modal state across all view components.
 * This centralizes the record detail viewing functionality to avoid duplication
 * and ensure consistent behavior across NoteView, TaskView, CalendarView, etc.
 * 
 * @typedef {Object} RecordDetailContextValue
 * @property {Object|null} selectedRecord - The currently selected record
 * @property {boolean} isOpen - Whether the detail modal is open
 * @property {string} mode - Display mode ('modal' or 'page')
 * @property {Function} openDetail - Function to open record detail
 * @property {Function} closeDetail - Function to close record detail
 * @property {Function} editRecord - Function to edit a record
 * @property {Function} deleteRecord - Function to delete a record
 * @property {Function} shareRecord - Function to share a record
 */

const RecordDetailContext = createContext(null);

export default RecordDetailContext;